import { App } from 'vue'
import TimePicker from './LpTimePicker.vue'

TimePicker.install = (Vue: App) => {
  Vue.component(TimePicker.name, TimePicker)
}

export default TimePicker
